import {Store} from '@ngrx/store';
import {DOCUMENT} from '@angular/common';
import {Component, Inject, OnInit, Renderer2} from '@angular/core';

import {getState} from '../../utils';
import {selectNewSalesForceChatConfig} from '../../../auth/selectors';

@Component({
  selector: 'st-sales-force-chat',
  template: ``,
})
export class SalesForceChatComponent implements OnInit  {
  constructor(private renderer: Renderer2, @Inject(DOCUMENT) private document: Document, private store: Store) {
  }
  ngOnInit(): void {
    const sfConfig = getState<{
      enableFeature: boolean;
      scriptUrl: string;
      cssUrl: string}>(this.store, selectNewSalesForceChatConfig);
    if (!sfConfig?.enableFeature) {
      return;
    }
    const sfScriptSrc = `${sfConfig.scriptUrl}${Date.now()}`;
    this.loadScript(sfScriptSrc);
    const sfCssSrc = `${sfConfig.cssUrl}${Date.now()}`;
    this.loadCss(sfCssSrc);
  }

  loadScript(scriptUrl: string): void {
    const sfScript = this.renderer.createElement('script');
    this.renderer.setAttribute(sfScript, 'src', scriptUrl);
    this.renderer.setAttribute(sfScript, 'async', 'async');
    this.renderer.appendChild(this.document.body, sfScript);
  }
  loadCss(cssUrl: string): void {
    const css = this.renderer.createElement('link');
    this.renderer.setAttribute(css, 'src', cssUrl);
    this.renderer.appendChild(this.document.body, css);
    this.document.head.appendChild(css);
  }
}
